
import React, { Component } from 'react'
import PackList from '../PackList'
import PackFocusList from '../PackFocusList'
import AdComponent from '../AdComponent'
import TitleContent from './TitleContent'
import TabTitle from './TabTitle'
import Tabs from 'antd/lib/tabs'
import Utils from '../../lib/utils'

if (__isBrowser__) {
  require('antd/lib/tabs/style/index.css')
}

const styles = require('./index.module.less')
const TabPane = Tabs.TabPane

export default class Tab extends Component {
  static defaultProps = {
    components: [], // 组件列表
    defaultActiveKey: '0', // 默认显示的tab索引 字符型
    tabTitle: [], // tabNav标题列表
    mainTitleLinks: [], // 主标题列表
    subRightLinkInfo: [], // 右侧标题
    moduleId: '',
    forceRender: false
  }

  constructor (props) {
    super(props)
    this.state = {
      key: this.props.defaultActiveKey ? (this.props.defaultActiveKey + '') : '0',
      forceRender: this.props.forceRender
    }
  }

  changeActityKey (params) {
    const activeKey = ((params.index) + '')
    if (activeKey === this.state.key) {
      return
    }
    this.setState({ key: activeKey, link: params.link })
  }

  render () {
    const tabClassName = this.props.tabType === 'TIME' ? styles.component_chasing : styles.component_tabs
    return (
      <Tabs ref={`tab_${this.props.moduleId}`}
        tabBarExtraContent={<TitleContent mainTitleLinks={this.props.mainTitleLinks} subRightLinkInfo={this.props.subRightLinkInfo} tabType={this.props.tabType} moduleId={this.props.moduleId} />}
        className={tabClassName}
        animated={false}>

        {
          this.props.components.map((component, index) => {
            return (
              <TabPane
                tab={<TabTitle index={index} tabTitle={this.props.tabTitle[index]} moduleId={this.props.moduleId} />}
                key={index}
                forceRender={this.state.forceRender}
                {...Utils.getComponentSpmData(component)}>
                {
                  component.headAdId ? <AdComponent data={{ adId: component.headAdId }} className={styles.tab_sponsor} showType={'tabheader'} /> : ''
                }
                {
                  (component.isFocus
                    ? <PackFocusList
                      moduleId={this.props.moduleId}
                      list={component.itemList}
                      isHorizontal={component.isHorizontal}
                      isOneLineTitle={component.isOneLineTitle} />
                    : <PackList list={component.itemList}
                      moduleId={this.props.moduleId}
                      isHorizontal={component.isHorizontal}
                      rank={component.isRank}
                      isOneLineTitle={component.isOneLineTitle}
                      row={component.totalLine || 2} />)
                }
              </TabPane>
            )
          })}
      </Tabs>)
  }
}
